import React from "react";
import { Link } from "react-router-dom";
import Footer from '../Components/Footer/Footer';
const Portfolio = () => {
	return (
		<div className="container" style={{ color: "white" }}>
			<h3 style={{ textAlign: "center", fontSize: 80 }}>Portfolio</h3>
			<h6 style={{ textAlign: "center", fontSize: 20 }}>
				{" "}
				<Link to="/">Home</Link> <span style={{ marginLeft: 20 }}> / </span>{" "}
				<span style={{ marginLeft: 20 }}> Portfolio </span>
			</h6>
			<div class="row" style={{ marginTop: 50 }}>
				<div class="col s12 m6 l4">
                <a href="https://github.com/ankur-b/FoodOrder" target="_blank" rel="noreferrer">
                <img src="https://github-readme-stats.vercel.app/api/pin/?username=ankur-b&repo=FoodOrder&theme=react" alt="" style={{width:'100%'}}/>
            </a>
				</div>
				<div class="col s12 m6 l4">
                <a href="https://github.com/ankur-b/Ecomm" target="_blank" rel="noreferrer">
                <img src="https://github-readme-stats.vercel.app/api/pin/?username=ankur-b&repo=Ecomm&theme=react" alt="" style={{width:'100%'}}/>
            </a>
				</div>
				<div class="col s12 m6 l4">
                <a href="https://github.com/ankur-b/Expense-Tracker" target="_blank" rel="noreferrer">
                <img src="https://github-readme-stats.vercel.app/api/pin/?username=ankur-b&repo=Expense-Tracker&theme=react" alt="" style={{width:'100%'}}/>
            </a>
				</div>
			</div>
            <div class="row" style={{ marginTop: -10 }}>
				<div class="col s12 m6 l4">
                <a href="https://github.com/ankur-b/Instagram-Clone" target="_blank" rel="noreferrer">
                <img src="https://github-readme-stats.vercel.app/api/pin/?username=ankur-b&repo=Instagram-Clone&theme=react" alt="" style={{width:'100%'}}/>
            </a>
				</div>
				<div class="col s12 m6 l4">
                <a href="https://github.com/ankur-b/Focustime" target="_blank" rel="noreferrer">
                <img src="https://github-readme-stats.vercel.app/api/pin/?username=ankur-b&repo=Focustime&theme=react" alt="" style={{width:'100%'}}/>
            </a>
				</div>
				<div class="col s12 m6 l4">
                <a href="https://github.com/ankur-b/Guess-a-Number" target="_blank" rel="noreferrer">
                <img src="https://github-readme-stats.vercel.app/api/pin/?username=ankur-b&repo=Guess-a-Number&theme=react" alt="" style={{width:'100%'}}/>
            </a>
				</div>
			</div>
            <div class="row" style={{ marginTop: -10 }}>
				<div class="col s12 m6 l4">
                <a href="https://github.com/ankur-b/tracks" target="_blank" rel="noreferrer">
                <img src="https://github-readme-stats.vercel.app/api/pin/?username=ankur-b&repo=tracks&theme=react" alt="" style={{width:'100%'}}/>
            </a>
				</div>
				<div class="col s12 m6 l4">
                <a href="https://github.com/ankur-b/track-server" target="_blank" rel="noreferrer">
                <img src="https://github-readme-stats.vercel.app/api/pin/?username=ankur-b&repo=track-server&theme=react" alt="" style={{width:'100%'}}/>
            </a>
				</div>
				<div class="col s12 m6 l4">
                <a href="https://github.com/ankur-b/widgets" target="_blank" rel="noreferrer">
                <img src="https://github-readme-stats.vercel.app/api/pin/?username=ankur-b&repo=widgets&theme=react" alt="" style={{width:'100%'}}/>
            </a>
				</div>
			</div>
           <div style={{marginTop:-65}}>
           <Footer/>
           </div>
		</div>
	);
};
export default Portfolio;
